import React from 'react';
import { useIntl } from 'react-intl-next';

import { SearchFooter } from '@atlassian/search-dialog';

import { messages } from '../messages';
import {
	AdvancedSearchFooter,
	type AdvancedSearchFooterProps,
} from '../../../advanced-search-footer';
import { SearchFooterWrapper, FeedbackLinkWrapper, FeedbackLink } from './styled';
import { useUserContext } from '../../../../common/user-context';
import { AtlassianHomeSearchLink } from '../../../advanced-search-footer/atlassian-home-search-link';
import { ReturnIconWithModifier } from '../../../advanced-search-footer/advanced-search-footer';
export interface WithTrelloFooterProps extends AdvancedSearchFooterProps {
	feedbackUrl?: string;
	showAtlassianHomeSearchLink?: boolean;
}

export const TrelloFooter = ({
	feedbackUrl,
	linkComponent,
	showAtlassianHomeSearchLink,
	...rest
}: WithTrelloFooterProps) => {
	const { formatMessage } = useIntl();
	const { orgId } = useUserContext();
	return (
		<SearchFooterWrapper>
			<AdvancedSearchFooter
				{...rest}
				returnKeyIconComponent={
					showAtlassianHomeSearchLink ? () => <ReturnIconWithModifier /> : undefined
				}
			/>
			{showAtlassianHomeSearchLink && orgId && (
				<SearchFooter>
					<AtlassianHomeSearchLink orgId={orgId} linkComponent={linkComponent} showModifierIcon />
				</SearchFooter>
			)}
			{feedbackUrl && (
				<FeedbackLinkWrapper>
					<FeedbackLink appearance="subtle-link" href={feedbackUrl} target="_blank">
						{formatMessage(messages.trello_feedback_link)}
					</FeedbackLink>
				</FeedbackLinkWrapper>
			)}
		</SearchFooterWrapper>
	);
};
